"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrash = void 0;
var react_1 = require("react");
var useCallback_1 = require("./useCallback");
function useCrash() {
    // https://github.com/facebook/react/issues/14981#issuecomment-468460187
    var _a = react_1.useState(null), setState = _a[1];
    return useCallback_1.useCallback(function (err) {
        return setState(function () {
            throw err;
        });
    }, [setState]);
}
exports.useCrash = useCrash;
//# sourceMappingURL=useCrash.js.map